import React from "react"
import Page from "../components/page"
import {SEO} from "../components/seo"
import Hero from "../components/hero"
import Bio from "../components/bio"
import Music from "../components/music"
import Contact from "../components/contact"
import * as styles from "./index.module.css"

export default function IndexPage() {
	return (
		<Page>
			<div className={styles.parallaxContainer}>
				<div className={styles.heroWrapper}>
					<Hero />
				</div>
				<div className={styles.contentWrapper}>
					<Bio />
					<Music />
					<Contact />
				</div>
			</div>
		</Page>
	)
}

export const Head = () => (
	<SEO description="Nate Weiner is a Minneapolis-based composer whose career has been built on connecting people to stories that matter. Best known as the founder and CEO of Pocket, he is now a composer for film, TV and video games." />
)
